import { cn } from '@/lib/cn';

export function PromptBlock({ label, body }: { label: string; body: string }) {
  return (
    <div className="space-y-1.5">
      <div className="flex items-center gap-1.5">
        <span className="h-1.5 w-1.5 rounded-full bg-muted-foreground/60" />
        <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">
          {label}
        </span>
      </div>
      <pre
        className={cn(
          'max-h-96 overflow-auto whitespace-pre-wrap rounded-md bg-muted/60 p-3 font-mono text-[11px] leading-relaxed',
        )}
      >
        {body}
      </pre>
    </div>
  );
}
